<template>
    <div>
        <div
            class="inline-flex w-full flex-col rounded-sm border border-gray-200 bg-white px-4 py-2 text-sm text-gray-600 shadow-lg"
        >
            <div class="flex w-full items-start justify-between">
                <div class="flex">
                    <svg
                        v-if="type === MessageTypes.WARNING"
                        class="text-warning-500 mt-[3px] mr-3 h-4 w-4 shrink-0 fill-current"
                        viewBox="0 0 16 16"
                    >
                        <path
                            d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z"
                        />
                    </svg>
                    <svg
                        v-else-if="type === MessageTypes.ERROR"
                        class="text-danger-500 mt-[3px] mr-3 h-4 w-4 shrink-0 fill-current"
                        viewBox="0 0 16 16"
                    >
                        <path
                            d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.5 10.1l-1.4 1.4L8 9.4l-2.1 2.1-1.4-1.4L6.6 8 4.5 5.9l1.4-1.4L8 6.6l2.1-2.1 1.4 1.4L9.4 8l2.1 2.1z"
                        />
                    </svg>
                    <svg
                        v-else-if="type === MessageTypes.SUCCESS"
                        class="text-success-500 mt-[3px] mr-3 h-4 w-4 shrink-0 fill-current"
                        viewBox="0 0 16 16"
                    >
                        <path
                            d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11.4L3.6 8 5 6.6l2 2 4-4L12.4 6 7 11.4z"
                        />
                    </svg>
                    <svg
                        v-else
                        class="text-info-500 mt-[3px] mr-3 h-4 w-4 shrink-0 fill-current"
                        viewBox="0 0 16 16"
                    >
                        <path
                            d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
                        />
                    </svg>
                    <div>
                        <slot />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { MessageTypes } from '@src/enums'

defineProps<{
    type: 'info' | 'warning' | 'error' | 'success'
}>()
</script>
